import {
  FRONTEND_STORAGE_KEYS,
  useSetStorageValueMutation,
} from "@js/apps/common/frontend-storage";
import { useShowCompleteProfileTopBar } from "@js/apps/dashboard/hooks/use-show-complete-profile-top-bar";
import { useNavigate } from "@js/hooks/navigate";

export const useCompleteProfileTopBar = () => {
  const navigate = useNavigate();
  const [setStorageValue] = useSetStorageValueMutation();
  const { showCompleteProfileTopBar } = useShowCompleteProfileTopBar();

  const dismissBar = () => {
    const currentDate = new Date().toUTCString();
    return setStorageValue({
      key: FRONTEND_STORAGE_KEYS.complete_profile_top_bar_dismissed_at,
      value: currentDate,
    });
  };

  const completeProfile = () => {
    navigate("/complete_profile");
  };

  return {
    dismissBar,
    showTopBar: showCompleteProfileTopBar,
    completeProfile,
  };
};
